import { Injectable } from '@angular/core';
import { IStepDataDef } from 'src/app/model/view/iqualification-def';
import { OrientationDefinitions } from './orientation-definitions';

@Injectable()
export class OrientationRepositoryService {

  constructor() { }

  public get specialSchoolOrientations(): IStepDataDef[] {
    return [
      OrientationDefinitions.DEF_OR_IMP_HEARING(),
      OrientationDefinitions.DEF_OR_IMP_VISUALLY(),
      OrientationDefinitions.SEVERE_LANG_DISORDER(),
      OrientationDefinitions.RETARDATION(),
      OrientationDefinitions.ACCORDING_TO_SPECIAL_TEACHER_DEGREE_TEACHING(),
    ];
  }
}
